import type { ReactNode } from "react";
import { useId } from "react";

type AppPopupProps = {
  actions: ReactNode;
  children: ReactNode;
  closeAriaLabel?: string;
  dismissible?: boolean;
  isOpen: boolean;
  onClose: () => void;
  panelClassName?: string;
  title: string;
};

export const AppPopup = ({
  actions,
  children,
  closeAriaLabel,
  dismissible = true,
  isOpen,
  onClose,
  panelClassName = "",
  title,
}: AppPopupProps) => {
  const titleId = useId();

  return (
    <section
      aria-hidden={!isOpen}
      className={`app-popup-overlay${isOpen ? " is-open" : ""}`}
      onClick={(event) => {
        if (dismissible && event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        aria-labelledby={titleId}
        aria-modal="true"
        className={`app-popup-panel ${panelClassName}`.trim()}
        role="dialog"
      >
        <div className="app-popup-header">
          <h2 className="app-popup-title" id={titleId}>
            {title}
          </h2>
          {dismissible ? (
            <button
              aria-label={closeAriaLabel ?? title}
              className="app-popup-close"
              onClick={onClose}
              type="button"
            >
              ✕
            </button>
          ) : null}
        </div>
        <div className="app-popup-body">{children}</div>
        <div className="app-popup-actions">{actions}</div>
      </div>
    </section>
  );
};
